import React from "react";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import WhatsAppIcon from "@mui/icons-material/WhatsApp";
import CloudDownloadIcon from "@mui/icons-material/CloudDownload";
import LogoUlo from "../../../components/LogoUlo/LogoUlo";
import { ContentUkm, UserResponse } from "../../../constants/types";
import CalendarFilter from "../../../components/Calendar/CalendarFilter";

type DateFilter = [Date | null, Date | null];

interface LaporanInactiveViewProps {
    apiExportLaporan: string;
    endDate: Date | null;
    isPhoneScreen: boolean;
    isTabletScreen: boolean;
    noWaAdmin?: {
        nomor?: string;
    };
    onDateRangeChange: (update: DateFilter) => void;
    startDate: Date | null;
    tanggalAkhir: string;
    tanggalAwal: string;
    today: Date;
    ukmData: ContentUkm;
    user?: UserResponse["data"];
}

function subtractMonths(numOfMonths: number, date = new Date()) {
    const result = new Date(date);
    result.setMonth(result.getMonth() - numOfMonths);
    return result;
}

function subtractYears(numOfYears: number, date = new Date()) {
    const result = new Date(date);
    result.setFullYear(result.getFullYear() - numOfYears);
    return result;
}

const LaporanInactiveView = ({
    apiExportLaporan,
    endDate,
    isPhoneScreen,
    isTabletScreen,
    noWaAdmin,
    onDateRangeChange,
    startDate,
    tanggalAkhir,
    tanggalAwal,
    today,
    ukmData,
    user,
}: LaporanInactiveViewProps) => {
    return (
        <Box
            display="flex"
            flexDirection="column"
            alignItems="center"
            justifyContent="center"
            bgcolor="#ffffff"
            gap={3}
            padding={2}
            sx={{
                height: isTabletScreen
                    ? "calc(100vh - 64px)"
                    : isPhoneScreen
                      ? "calc(100vh - 56px)"
                      : "100vh",
            }}
        >
            <Box
                display="flex"
                flexDirection="column"
                justifyContent="center"
                alignItems="center"
            >
                <LogoUlo width="100px" />
                <Typography marginTop={2} textAlign="center">
                    Mohon maaf, ukm anda berstatus tidak aktif
                </Typography>
                {ukmData.isPro === 1 ? (
                    <Typography textAlign="center">
                        Anda tetap bisa melakukan unduh laporan.
                    </Typography>
                ) : null}
            </Box>
            {ukmData.isPro === 1 ? (
                <Box
                    display="flex"
                    flexDirection="column"
                    gap={2}
                    justifyContent="center"
                    alignItems="center"
                >
                    <CalendarFilter
                        value={{
                            from: startDate ?? undefined,
                            to: endDate ?? undefined,
                        }}
                        onApply={(range) =>
                            onDateRangeChange([
                                range.from ?? null,
                                range.to ?? null,
                            ])
                        }
                        maxDate={today}
                        minDate={
                            ukmData.isPro === 1
                                ? subtractYears(1)
                                : subtractMonths(3)
                        }
                    />
                    <Button
                        disabled={user && !user.akses.laporan.includes(31)}
                        variant="contained"
                        onClick={() => {
                            window.open(apiExportLaporan, "_blank");
                        }}
                        startIcon={<CloudDownloadIcon />}
                        color="ulo"
                        sx={{ minWidth: "200px" }}
                    >
                        Unduh Laporan
                    </Button>
                </Box>
            ) : (
                <Button
                    variant="outlined"
                    startIcon={<WhatsAppIcon />}
                    target="_blank"
                    color="ulo"
                    href={`https://wa.me/${noWaAdmin?.nomor}?text=Kenapa%20toko%20saya%20yaitu%20${ukmData.namaToko}%20berstatus%20tidak%20aktif?`}
                >
                    Hubungi Kami
                </Button>
            )}
        </Box>
    );
};

export default LaporanInactiveView;
